import { InputState, Props as IReactInputMask } from 'react-input-mask';

export enum LangValueType {
  ru = 'ru',
  en = 'en',
  fr = 'fr',
  qz = 'qz',
  uk = 'uk',
  vn = 'vn',
  ph = 'ph',
  si = 'si',
  pl = 'pl',
  md = 'md',
  ro = 'ro',
}

export enum LangLabelType {
  en = 'English',
  ru = 'Русский',
  fr = 'Français',
  qz = 'Қазақша',
  uk = 'uk',
  vn = 'vn',
  ph = 'ph',
  si = 'si',
  pl = 'pl',
  md = 'md',
  ro = 'ro',
}

export interface LangOption {
  value: LangValueType;
  label: LangLabelType;
  isActive: boolean;
}

export type SelectOptionType = {
  value: string | number;
  label: string;
};

export interface IMaskedProps
  extends Pick<IReactInputMask, 'alwaysShowMask' | 'beforeMaskedStateChange' | 'mask'> {
  beforeMaskedValueChange?: (
    newState: InputState,
    oldState: InputState,
    userInput: string
  ) => InputState;
  maskChar?: string;
  formatChars?: {
    [key: string | number]: string;
  };
}

export type InputModeType = 'numeric' | 'tel' | 'email' | 'text';

export type InputModeTextAreaType =
  | 'none'
  | 'text'
  | 'tel'
  | 'url'
  | 'email'
  | 'numeric'
  | 'decimal'
  | 'search';

export interface TimerValueReturned {
  fullString: string;
  hoursString: string;
  secondString: string;
  minutesString: string;
  secondsNumber: number;
  isMounted: boolean;
}
